import React from "react";

export function Card({ image, name, stream, company }) {
  return (
    <div className="flex justify-center">
      <div className="flex flex-col mx-5 h-full items-center">
        <div className="flex justify-center w-[200px] h-[200px] mb-4">
          <img
            src={image}
            alt={name}
            className="w-full h-full rounded-full object-cover border-4 border-white/10 shadow-xl hover:border-[#2dd4bf] hover:scale-105 transition-all duration-500"
          />
        </div>
        <div className="flex flex-col justify-center text-center">
          <h1 className="text-[20px] leading-[28px] font-bold text-white mb-2 tracking-wide">
            {name}
          </h1>
          <p className="text-[14px] font-medium text-slate-300 mb-1">
            {stream}
          </p>
          <p className="text-[14px] text-[#2dd4bf] font-semibold tracking-wider uppercase">
            {company}
          </p>
        </div>
      </div>
    </div>
  );
}
